// typings

import { create } from "zustand";

import { IUsuarioClienteState } from "@/store-zustand/usuarios-do-clientes/index.d";

// criação da store com Zustand (usuarios do cliente)
export const useStoreZustandUsuarioCliente = create<IUsuarioClienteState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  usuarioCliente: [],
  paginations: [],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  isModalInativarUsuarioDoCliente: false,
  isModalCadastrarUsuarioDoCliente: false,
  isModalExcluirUsuarioDoCliente: false,
  isModalEditarUsuarioDoCliente: false,
  usuarioClienteSelecionado: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setUsuarioCliente: (usuarioCliente) => set({ usuarioCliente }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setisModalInativarUsuarioDoCliente: (isModalInativarUsuarioDoCliente) =>
    set({ isModalInativarUsuarioDoCliente }),
  setUsuarioClienteSelecionado: (usuarioClienteSelecionado) => set({ usuarioClienteSelecionado }),
  setIsModalCadastrarUsuarioDoCliente: (isModalCadastrarUsuarioDoCliente) =>
    set({ isModalCadastrarUsuarioDoCliente }),
  setIsModalExcluirUsuarioDoCliente: (isModalExcluirUsuarioDoCliente) =>
    set({ isModalExcluirUsuarioDoCliente }),
  setIsModalEditarUsuarioDoCliente: (isModalEditarUsuarioDoCliente) =>
    set({ isModalEditarUsuarioDoCliente }),
}));
